<template>
  <!-- Section Form Booked-->
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-account mc-account--login">
        <form v-if="step==1" @submit.prevent="getCode" class="mc-account__form mc-form" id="accountLogin" method="post" autocomplete="off">
          <p v-if="authChannel === 'sms'" class="mc-form__notice mc-form__notice--lg mc-form__notice--centered">
            На указанный телефон будет отправлен код подтверждения
          </p>
          <p v-else class="mc-form__notice mc-form__notice--lg mc-form__notice--centered">
            На указанный email будет отправлен код подтверждения
          </p>
          <div class="mc-form__body">
            <div v-if="serverError" class="mc-form__message mc-form__message--alert" v-html="serverError"></div>
            <section class="mc-account__tabs mc-tabs mc-tabs--fr" aria-label="Способ входа">
              <div class="mc-tabs__button-wrapper">
                <ul class="mc-tabs__list">
                  <li ref="authTabSms" class="mc-tabs__item" :class="{ isActive: authChannel === 'sms' }" @click="setAuthChannel('sms')">
                    <button class="mc-tabs__button js-button-tab" type="button" :aria-pressed="authChannel === 'sms'">
                      По телефону
                    </button>
                  </li>
                  <li ref="authTabEmail" class="mc-tabs__item" :class="{ isActive: authChannel === 'email' }" @click="setAuthChannel('email')">
                    <button class="mc-tabs__button js-button-tab" type="button" :aria-pressed="authChannel === 'email'">
                      По email
                    </button>
                  </li>
                  <li class="mc-tabs__glide" :style="authTabGlide"></li>
                </ul>
              </div>
            </section>
            <fieldset class="mc-form__fieldset">
              <div v-if="authChannel === 'sms'" class="mc-form__field field_phone" :class="{ isError: error.includes('phone') }">
                <label class="mc-form__label" for="accountLoginPhone">
                  {{ contactLabel }}
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="error.includes('phone')" class="mc-form__error-text">
                  {{ errors.phone }}
                </span>
                <MaskInput class="mc-form__input" id="accountLoginPhone" v-model="formData.phone" mask="+7 (###) ###-##-##" placeholder="+7 (___) ___-__-__" required />
              </div>
              <div v-else class="mc-form__field field_email" :class="{ isError: error.includes('email') }">
                <label class="mc-form__label" for="accountLoginEmail">
                  Email
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="error.includes('email')" class="mc-form__error-text">
                  {{ errors.email }}
                </span>
                <input class="mc-form__input" id="accountLoginEmail" v-model="formData.email" type="email" placeholder="example@mail.ru" autocomplete="email" required>
              </div>
            </fieldset>
          </div>
          <div class="mc-form__bottom">
            <button class="mc-button mc-button--color" type="submit" :disabled="sending">
              Получить код
            </button>
          </div>
        </form>
        <form v-if="step==2" @submit.prevent="auth" class="mc-account__form mc-form" id="accountLogin2" method="post" autocomplete="off">
          <p v-if="authChannel === 'sms'" class="mc-form__notice mc-form__notice--lg mc-form__notice--centered">
            Впишите код полученный в смс
          </p>
          <p v-else class="mc-form__notice mc-form__notice--lg mc-form__notice--centered">
            Впишите код, полученный по email
          </p>
          <div class="mc-form__body">
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__field">
                <label class="mc-form__label" for="accountLoginPhone">
                  {{ contactLabel }}
                  <span class="mc-form__asterisk">*</span>
                </label>
                <div class="mc-form__input" id="accountLoginPhone">{{ confirmedContact }}</div>
              </div>
              <div class="mc-form__field field_code" :class="{ isError: error.includes('code') }">
                <label class="mc-form__label" for="accountLoginPhone">
                  Код подтверждения
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="error.includes('code')" class="mc-form__error-text">
                  {{ errors.code }}
                </span>
                <MaskInput ref="code" class="mc-form__input" v-model="formData.code" mask="####" placeholder="____" required />
              </div>
            </fieldset>
          </div>
          <div class="mc-form__bottom">
            <button class="mc-button mc-button--color" type="submit" :disabled="sending">
              Подтвердить
            </button>
            <button class="mc-button" type="button" :disabled="sending" @click="backToRequest">
              Изменить
            </button>
          </div>
        </form>
        <form v-if="step==3" @submit.prevent="reg" class="mc-account__form mc-form" id="accountRegistration" action="https://httpbin.org/anything" method="post" autocomplete="off">
          <div class="mc-form__body">
            <div v-if="serverError" class="mc-form__message mc-form__message--alert" v-html="serverError"></div>
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__field" :class="{ isError: errors.surname }">
                <label class="mc-form__label" for="personalDataSurname">
                  Фамилия
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.surname" class="mc-form__error-text">
                  {{ errors.surname }}
                </span>
                <input class="mc-form__input" required id="personalDataSurname" type="text" v-model="formData.surname" name="surname" placeholder="Иванова" >
              </div>
              <div class="mc-form__field" :class="{ isError: errors.name }">
                <label class="mc-form__label" for="personalDataName">
                  Имя
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.name" class="mc-form__error-text">
                  {{ errors.name }}
                </span>
                <input class="mc-form__input" id="personalDataName" type="text" v-model="formData.name" name="name" placeholder="Елена" required>
              </div>
              <div class="mc-form__field" :class="{ isError: errors.patronymic }">
                <label class="mc-form__label" for="personalDataPatronymic">
                  Отчество
                </label>
                <span v-if="errors.patronymic" class="mc-form__error-text">
                  {{ errors.patronymic }}
                </span>
                <input class="mc-form__input" id="personalDataPatronymic" type="text" v-model="formData.patronymic" name="patronymic" placeholder="Ивановна">
              </div>
              <div v-if="authChannel === 'email'" class="mc-form__field field_phone" :class="{ isError: errors.phone }">
                <label class="mc-form__label" for="personalDataPhone">
                  Телефон
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.phone" class="mc-form__error-text">
                  {{ errors.phone }}
                </span>
                <MaskInput class="mc-form__input" id="personalDataPhone" v-model="formData.phone" mask="+7 (###) ###-##-##" placeholder="+7 (___) ___-__-__" required />
              </div>
              <div class="mc-form__field" :class="{ isError: errors.email }">
                <label class="mc-form__label" for="personalDataEmail">
                  E-mail
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.email" class="mc-form__error-text">
                  {{ errors.email }}
                </span>
                <input class="mc-form__input" id="personalDataEmail" type="email" v-model="formData.email" name="email" placeholder="example@mail.ru" :readonly="authChannel === 'email'" required>
              </div>
              <div class="mc-form__field" :class="{ isError: errors.gender }">
                <label class="mc-form__label" for="accountRegistrationGender">
                  Пол
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.gender" class="mc-form__error-text">
                  {{ errors.gender }}
                </span>
                <div class="mc-form__radio-group mc-form__radio-group_gender">
                  <ul class="mc-form__radio-list">
                    <li class="mc-form__radio-item">
                      <div class="mc-form__radio-field">
                        <input class="mc-form__radio-input" v-model="formData.gender" id="genderF" type="radio" value="F">
                        <label class="mc-form__radio-label" for="genderF">Женский</label>
                      </div></li>
                    <li class="mc-form__radio-item">
                      <div class="mc-form__radio-field">
                        <input class="mc-form__radio-input" v-model="formData.gender" id="genderM" type="radio" value="M">
                        <label class="mc-form__radio-label" for="genderM">Мужской</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="mc-form__field" :class="{ isError: errors.birthdate }">
                <label class="mc-form__label">
                  Дата рождения
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.birthdate" class="mc-form__error-text">
                  {{ errors.birthdate }}
                </span>
                <div class="mc-form__date mc-date">
                  <div class="mc-date__field">
                    <MaskInput class="mc-date__input" id="personalDataBirthdayDay" v-model="formData.day" mask="##" placeholder="__" required />
                  </div>
                  <div class="mc-date__middle">
                    <button @click="isMonthModalOpen = true" class="mc-date__select-button js-modal-button" data-target="personalDataBirthdayMonth" type="button">
                      {{ selectedMonth }}
                    </button>
                    <div class="mc-modal" :class="{ isOpen: isMonthModalOpen }" id="personalDataBirthdayMonth">
                      <div class="mc-modal__outer">
                        <div class="mc-modal__inner">
                          <div class="mc-modal__heading">
                            <button class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                              <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                                <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                              </svg>
                            </button>
                            <div class="mc-modal__title">
                              Месяц
                            </div>
                          </div>
                          <div class="mc-modal__body">
                            <ul class="mc-filter__option-list mc-options">
                              <li v-for="(month, index) in months" :key="index" class="mc-options__item">
                                <button
                                    class="mc-options__button"
                                    :class="{ isSelected: selectedMonth === month }"
                                    type="button"
                                    @click="selectMonth(month, index+1)">
                                  {{ month }}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div class="mc-modal__bottom">
                            <button @click="isMonthModalOpen = false" class="mc-button mc-button--color js-button-close" type="button">
                              <span class="mc-button__text">
                                Закрыть
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mc-date__field">
                    <MaskInput class="mc-date__input" id="personalDataBirthdayYear" v-model="formData.year" mask="####" placeholder="____" required />
                  </div>
                </div>
                <p class="mc-form__notice">
                  Установить дату рождения в личном кабинете можно только один раз. Для изменения даты рождения - обратитесь к администратору сайта&nbsp;<a href="#">info@fashionstore.ru</a>.
                </p>
              </div>
            </fieldset>
            <div class="mc-form__field">
              <input class="mc-form__checkbox" type="checkbox" v-model="formData.subscribe" id="checkbox-0">
              <label class="mc-form__label" for="checkbox-0">
                Подписаться на рассылку
              </label>
            </div>
            <p class="mc-form__notice">
              Нажимая на кнопку "Завершить оформление" вы принимаете условия&nbsp;<a href="#">Публичной оферты</a>
            </p>
            <button class="mc-button mc-button--color" type="submit" :disabled="sending">
              {{ sending ? 'Отправка...' : 'Завершить регистрацию' }}
            </button>
          </div>
        </form>
        <ul class="mc-account__menu mc-account-menu">
          <li class="mc-account-menu__item">
            <router-link to="/contacts/" class="mc-account-menu__link">
                                <span class="mc-account-menu__link-title">
                                    Контакты
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/loyalty/" class="mc-account-menu__link">
                                <span class="mc-account-menu__link-title">
                                    Программа лояльности
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/certificates/" class="mc-account-menu__link">
                                <span class="mc-account-menu__link-title">
                                    Подарочные сертификаты
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/blog/" class="mc-account-menu__link" href="#">
                                <span class="mc-account-menu__link-title">
                                    Новости
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/info/" class="mc-account-menu__link">
                                <span class="mc-account-menu__link-title">
                                    Информация
                                </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { MaskInput } from 'vue-3-mask';
import checkAuth from '../mixin/checkAuth'

export default {
  components: {
    MaskInput
  },
  mixins: [checkAuth],
  beforeRouteLeave(to, from) {
    //if (to.name != 'login')
    //  this.$store.dispatch('unLoader');
  },
  created() {

  },
  computed: {
    contactLabel() {
      return this.authChannel === 'email' ? 'Email' : 'Телефон';
    }
  },
  async mounted() {
    this.$nextTick(() => this.setAuthTabActive());
  },
  methods: {
    setAuthChannel(channel) {
      if (this.sending || this.step !== 1) {
        return;
      }
      this.authChannel = channel;
      this.error = [];
      this.error_text = [];
      this.errors = {};
      this.serverError = '';
      this.formData.code = '';
      this.$nextTick(() => this.setAuthTabActive());
    },
    setAuthTabActive() {
      const tab = this.authChannel === 'email' ? this.$refs.authTabEmail : this.$refs.authTabSms;
      if (!tab || !tab.parentElement) {
        return;
      }
      const parentRect = tab.parentElement.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      this.authTabGlide = {
        left: (tabRect.left - parentRect.left) + 'px',
        top: (tabRect.top - parentRect.top) + 'px',
        width: tab.offsetWidth + 'px',
        height: tab.offsetHeight + 'px'
      };
    },
    backToRequest() {
      this.step = 1;
      this.authToken = '';
      this.confirmedContact = '';
      this.formData.code = '';
      this.error = [];
      this.error_text = [];
      this.errors = {};
      this.serverError = '';
      this.$nextTick(() => this.setAuthTabActive());
    },
    collectErrors(response) {
      this.serverError = '';
      const errors = response && response.data ? response.data.errors : null;
      if (!errors) {
        this.serverError = 'Произошла техническая ошибка. Попробуйте еще раз.';
        return;
      }
      for (const item of errors) {
        if (item.code && typeof item.code !== 'number') {
          this.errors[item.code] = item.message;
          this.error.push(item.code);
        } else {
          this.serverError += item.message + '<br>';
        }
      }
    },
    selectMonth(month, monthIndex) {
      this.selectedMonth = month;
      this.formData.month = monthIndex;
      // Close modal (assuming you have JS that toggles modal visibility)
      const closeButtons = document.querySelectorAll('.js-button-close');
      if (closeButtons.length) {
        closeButtons[0].click();
      }
    },

    scrollToFirstError() {
      this.$nextTick(() => {
        // Find first error element or server error message
        const firstErrorElement = this.serverError
            ? document.querySelector('.mc-form__message--alert')
            : document.querySelector('.isError');

        if (firstErrorElement) {
          // Scroll to the element with smooth behavior
          firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },

    validateForm() {
      this.errors = {};

      // Validate phone - with mask we can simplify the validation
      if (!this.formData.phone) {
        this.errors.phone = 'Телефон обязателен';
        return false;
      } else if (this.formData.phone.includes('_')) {
        this.errors.phone = 'Введите корректный телефон';
        return false;
      }

      // Validate surname
      if (!this.formData.surname.trim()) {
        this.errors.surname = 'Фамилия обязательна';
      } else if (this.formData.surname.length < 2) {
        this.errors.surname = 'Фамилия должна содержать минимум 2 символа';
      }

      // Validate name
      if (!this.formData.name.trim()) {
        this.errors.name = 'Имя обязательно';
      } else if (this.formData.name.length < 2) {
        this.errors.name = 'Имя должно содержать минимум 2 символа';
      }

      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.formData.email.trim()) {
        this.errors.email = 'Email обязателен';
      } else if (!emailRegex.test(this.formData.email)) {
        this.errors.email = 'Некорректный формат email';
      }

// Validate name
      console.log(this.formData)
      if (this.formData.gender !== 'F' && this.formData.gender !== 'M') {
        this.errors.gender = 'Пол обязателен';
      }

      // Validate birth date
      const day = parseInt(this.formData.day);
      const year = parseInt(this.formData.year);

      if (!day || !year) {
        this.errors.birthdate = 'Дата рождения обязательна';
      } else if (day < 1 || day > 31) {
        this.errors.birthdate = 'Некорректный день';
      } else if (year < 1900 || year > new Date().getFullYear()) {
        this.errors.birthdate = 'Некорректный год';
      }

      const isValid = Object.keys(this.errors).length === 0;

      if (!isValid) {
        this.scrollToFirstError();
      }

      return isValid;
    },
    getCode: function(e) {
      if (this.sending === true)
        return;
      let formData = new FormData(),
          _this = this;
      let top = 0;
      this.error = [];
      this.error_text = [];
      this.errors = {};

      formData.append('channel', this.authChannel);
      formData.append('login', this.authChannel === 'email' ? this.formData.email : this.formData.phone);

      if (this.authChannel === 'sms' && (!this.formData.phone || this.formData.phone.includes('_'))) {
        this.error.push('phone');
        this.errors.phone = 'Введите корректный телефон';
        top = document.querySelector(".field_phone").offsetTop;
      }
      if (this.authChannel === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.formData.email.trim())) {
          this.error.push('email');
          this.errors.email = 'Введите корректный email';
          top = document.querySelector(".field_email").offsetTop;
        }
      }

      if (this.error.length == 0) {
        this.sending = true;
        axios.post( 'api/user/code/',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(function(response){
          if (response.data.status == 'success') {
            _this.authToken = response.data.data.token;
            _this.confirmedContact = response.data.data.maskedContact
                || (_this.authChannel === 'email' ? _this.formData.email : _this.formData.phone);
            _this.step=2;
            _this.sending = false;
            _this.$nextTick(() => {
              const codeInput = document.querySelector(".field_code input");
              if (codeInput) {
                codeInput.focus();
              }
            });
          }
          else {
            _this.error_text = response.data.errors;
            _this.sending = false;
            _this.collectErrors(response);
          }
        })
            .catch(function(){
              _this.sending = false;
            });
      }
      else {
        window.scrollTo(0, top);
      }
    },
    auth: function(e) {
      if (this.sending === true)
        return;
      let formData = new FormData(),
          _this = this;
      let top = 0;
      this.error = [];
      this.error_text = [];
      this.errors = {};

      formData.append('token', this.authToken);
      formData.append('code', this.formData.code);

      if (!this.formData.code) {
        this.error.push('code');
        this.errors.code = 'Введите код';
        top = document.querySelector(".field_code").offsetTop;
      }
      if (!this.authToken) {
        this.serverError = 'Запросите код подтверждения повторно.';
      }

      if (this.error.length == 0 && !this.serverError) {
        formData.append('uuid', this.$store.getters.device_uuid);
        this.sending = true;
        axios.post( 'api/user/code/confirm/',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(function(response){
          if (response.data.status == 'success') {
            if (response.data.data.step == 3) {
              _this.step=response.data.data.step;
              _this.authToken = response.data.data.token || _this.authToken;
              if (response.data.data.phone) {
                _this.formData.phone = response.data.data.phone;
              }
              if (response.data.data.email) {
                _this.formData.email = response.data.data.email;
              }
              _this.$nextTick(() => {
                document.querySelector("#personalDataSurname").focus();
              });
            }
            else {
              let data = response.data.data;
              data.device = _this.$store.getters.device;
              data.uuid = _this.$store.getters.device_uuid;
              _this.$store.dispatch('Auth', data)
              _this.$router.push('/profile/');
            }
            _this.sending = false;
          }
          else {
            _this.error_text = response.data.errors[0]['message'];
            _this.errors.code = response.data.errors[0]['message'];
            _this.error.push('code');
            _this.sending = false;
          }
        })
            .catch(function(){
              _this.sending = false;
            });
      }
      else {
        window.scrollTo(0, top);
      }
    },
    async reg() {
      if (!this.validateForm()) {
        return;
      }

      this.sending = true;
      this.serverError = null;

      try {
        // Prepare data for submission
        const formDataToSubmit = {
          ...this.formData,
          birthdate: `${this.formData.year}-${this.formData.month}-${this.formData.day}`,
          token: this.authToken,
          channel: this.authChannel,
          uuid: this.$store.getters.device_uuid
        };

        // Remove the individual date fields that we merged
        delete formDataToSubmit.day;
        delete formDataToSubmit.month;
        delete formDataToSubmit.year;

        const response = await axios.post('/api/user/register/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code != 'number' && response.data.errors[i].code!= 'phone')
              this.errors[response.data.errors[i].code] = response.data.errors[i].message;
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(response.data.errors);
        }

        this.formSubmitted = true;

        const data = response.data.data;
        data.device = this.$store.getters.device;
        data.uuid = this.$store.getters.device_uuid;
        this.$store.dispatch('Auth', data)
        this.$router.push('/profile/');
        // Scroll to the success message
        /*this.$nextTick(() => {
          const successMessage = document.querySelector('.mc-form__message--success');
          if (successMessage) {
            successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });*/

      } catch (error) {
        //console.log(error)
        //console.log(this.errors)
        //let errorMessage = 'Произошла техническая ошибка. Попробуйте еще раз.';
/*
        if (error.response && error.response.data) {
          // Handle axios error responses
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.message) {
          // Use the thrown error message
          errorMessage = error.message;
        }*/

        //this.serverError = errorMessage;
        this.scrollToFirstError();
      } finally {
        this.sending = false;
      }
    }
  },
  data: () => ({
    error: [],
    errors: {},
    sending: false,
    error_text: [],
    step: 1,
    authChannel: 'sms',
    authToken: '',
    confirmedContact: '',
    authTabGlide: {
      left: '0px',
      top: '0px',
      width: '0px',
      height: '0px'
    },
    formData: {
      code: '',
      surname: '',
      name: '',
      patronymic: '',
      email: '',
      phone: '',
      day: '',
      month: 1, // Default to September (index 9)
      year: '',
      subscribe: '',
      gender: false
    },
    serverError: '',
    isMonthModalOpen: false,
    selectedMonth: 'Январь',
    months: [
      'Январь', 'Февраль', 'Март', 'Апрель',
      'Май', 'Июнь', 'Июль', 'Август',
      'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ],
  }),
}
</script>
